import React from "react";

interface AuthFormProps {
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => Promise<void>;
  errorMessage?: string | null;
  successMessage?: string | null;
  bottomContent?: React.ReactNode;
}

export default function AuthForm({
  children,
  onSubmit,
  errorMessage,
  successMessage,
  bottomContent
}: AuthFormProps) {
  return (
    <div>
      {/* Success message */}
      {successMessage && (
        <div className="p-4 mb-6 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-900/30 dark:text-green-400">
          {successMessage}
        </div>
      )}
      
      {/* Error message */}
      {errorMessage && (
        <div className="p-4 mb-6 text-sm text-red-700 bg-red-100 rounded-lg dark:bg-red-900/30 dark:text-red-400">
          {errorMessage}
        </div>
      )}
      
      <form onSubmit={onSubmit}>
        <div className="space-y-6">
          {children}
        </div>
      </form>

      {bottomContent && (
        <div className="mt-5">
          {bottomContent}
        </div>
      )}
    </div>
  );
} 